import { Model } from '../Model.js';
import equals from 'fast-deep-equal';
import { PriceDetailMapper } from '../Price/PriceDetailMapper.js';

var _dec, _class;

/**
 * Every type that has a reference.
 */

/**
 * Plain object Invoice representation.
 *
 */

/**
 * Serialized object Invoice representation.
 *
 */

/**
 * Plain object Packlink's API response representation.
 *
 */

/**
 * Packlink's API response for the Invoices endpoint.
 *
 */

let Invoice = (_dec = Model(), _dec(_class = class Invoice {
  /**
   * Takes a IInvoiceApiResponse from Packlink's API and returns a Invoice.
   *
   * @param response  IInvoiceApiResponse response from Packlink's API.
   *
   */
  static createFromResponse(response) {
    return new Invoice(response.country, response.created_at, response.packlink_reference, response.paid, response.paid_at, response.payer_email, response.platform, response.reference, response.shipment_references, response.status, response.type, response.has_invoice_pdf, PriceDetailMapper.createModelFromResponse(response.price));
  }

  /**
   * Takes a serialized Invoice and returns a Invoice.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Invoice.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedInvoice.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Invoice.
   *
   */

  /**
   * Takes a serialized Invoice and returns a Invoice.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Invoice.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedInvoice.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Invoice.
   *
   */

  /**
   * Takes a serialized Invoice and returns a Invoice.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Invoice.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedInvoice.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Invoice.
   *
   */

  /**
   * Takes a serialized Invoice and returns a Invoice.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Invoice.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedInvoice.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Invoice.
   *
   */
  static deserialize(data) {
    if (!data) {
      return;
    }
    return new Invoice(data.country, data.createdAt, data.packlinkReference, data.paid, data.paidAt, data.payerEmail, data.platform, data.reference, data.shipmentReferences, data.status, data.type, data.hasInvoicePdf, {
      ...data.price
    });
  }

  /**
   * Returns a new Invoice. Typings of the properties depend on the class type param T
   *
   */
  constructor(country, createdAt, packlinkReference, paid, paidAt, payerEmail, platform, reference, shipmentReferences, status, type, hasInvoicePdf, price) {
    this.country = country;
    this.createdAt = createdAt;
    this.packlinkReference = packlinkReference;
    this.paid = paid;
    this.paidAt = paidAt;
    this.payerEmail = payerEmail;
    this.platform = platform;
    this.reference = reference;
    this.shipmentReferences = shipmentReferences;
    this.status = status;
    this.type = type;
    this.hasInvoicePdf = hasInvoicePdf;
    this.price = price;
  }

  /**
   * Returns a JSON serialized version of the Invoice.
   *
   */
  toJSON() {
    return {
      country: this.country,
      createdAt: this.createdAt,
      hasInvoicePdf: this.hasInvoicePdf,
      packlinkReference: this.packlinkReference,
      paid: this.paid,
      paidAt: this.paidAt,
      payerEmail: this.payerEmail,
      platform: this.platform,
      price: this.price,
      reference: this.reference,
      shipmentReferences: this.shipmentReferences,
      status: this.status,
      type: this.type
    };
  }

  /**
   * Returns a clone of the Invoice.
   *
   */
  clone() {
    return new Invoice(this.country, this.createdAt, this.packlinkReference, this.paid, this.paidAt, this.payerEmail, this.platform, this.reference, this.shipmentReferences, this.status, this.type, this.hasInvoicePdf, {
      ...this.price
    });
  }

  /**
   * Returns whether the two Invoice are equal.
   *
   */
  equals(invoice) {
    var _this$shipmentReferen;
    if (!invoice) {
      return false;
    }
    return this.country === invoice.country && this.createdAt === invoice.createdAt && this.packlinkReference === invoice.packlinkReference && this.paid === invoice.paid && this.paidAt === invoice.paidAt && this.payerEmail === invoice.payerEmail && this.platform === invoice.platform && equals(this.price, invoice.price) && this.reference === invoice.reference && !!((_this$shipmentReferen = this.shipmentReferences) !== null && _this$shipmentReferen !== void 0 && _this$shipmentReferen.every((element, index) => {
      var _invoice$shipmentRefe;
      return element.reference === ((_invoice$shipmentRefe = invoice.shipmentReferences) === null || _invoice$shipmentRefe === void 0 ? void 0 : _invoice$shipmentRefe[index].reference);
    })) && this.status === invoice.status && this.type === invoice.type && this.hasInvoicePdf === invoice.hasInvoicePdf;
  }
}) || _class);

export { Invoice };
//# sourceMappingURL=Invoice.js.map
